import { Button } from "antd";
import { InboxOutlined, WarningOutlined } from "@ant-design/icons";

// One layout for every "there is nothing to show" panel: icon, title,
// optional description, optional CTA. Screens only supply copy + action.
const VARIANTS = {
  empty: { Icon: InboxOutlined, color: "#c7c9d3" },
  error: { Icon: WarningOutlined, color: "#F59E0B" },
};

const StateView = ({
  variant = "empty",
  icon,
  title,
  description,
  actionLabel,
  onAction,
}) => {
  const preset = VARIANTS[variant] ?? VARIANTS.empty;
  const Icon = preset.Icon;

  return (
    <div className="flex flex-col items-center justify-center px-8 py-12 text-center">
      {icon ?? <Icon style={{ fontSize: 48, color: preset.color }} />}

      <div className="mt-4 text-base font-semibold text-black">{title}</div>

      {description && (
        <div className="mt-2 max-w-md text-sm text-secondary">{description}</div>
      )}

      {actionLabel && onAction && (
        <Button
          className="mt-5"
          onClick={() => onAction()}
          style={{ borderColor: "#b4c540", color: "#b4c540" }}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default StateView;
